import { VehicleCheckListComponent } from './components/vehiclechecklistList.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { EcplChecklistViewerModule } from '../../shared/ecpl-checklist-viewer';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'primeng/api';
import { EditorModule } from 'primeng/editor';
import { DatePickerModule } from 'primeng/datepicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';

@NgModule({ exports: [VehicleCheckListComponent],
    declarations: [VehicleCheckListComponent],
  imports: [
    BrowserModule,
    TableModule,
    SharedModule,
    FormsModule,
        DatePickerModule,
    EditorModule,
    ContextMenuModule,
    MenuModule,
    DialogModule,
    ReactiveFormsModule,
        SelectModule,
        TextareaModule,
    InputTextModule,
    TranslatePipe, TranslateDirective,
    AppSharedModule,
    RouterModule,
    ButtonModule,
    NgxPaginationModule,
    EcplChecklistViewerModule
  ], providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class VehicleChecklistModule {}
